import {
    type UploadTokenResponseType,
    type UploadTokenRequestType
} from "./type";
import {
    request
} from "../request";

const GetUploadTokenForEventPhoto = async (params: UploadTokenRequestType): Promise<UploadTokenResponseType> => {
    return await request<UploadTokenResponseType>("/events/getUploadTokenForEventPhoto", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default GetUploadTokenForEventPhoto;
